import { QuestionOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useCreateForm } from '../../hooks/use-create-form';
import { AveliosButton } from '../common-layout/avelios-button';
import styles from './facility-selection.module.scss';

interface FacilityFormProps {
  clinicId: string;
  facilityId: string;
  officeHourId: string;
  formTemplateVersioningGroupId: string;
  formObjectKey: string;
}

const buildFormForwardUrl = (
  facilityId: string,
  clinicId: string,
  officeHourId: string,
  formObjectKey: string,
  formRevisionGroupId: string,
): string => {
  return `/facility-selection?facilityId=${facilityId}&clinicId=${clinicId}&officeHourId=${officeHourId}&${formObjectKey}=${formRevisionGroupId}`;
};

export const FacilityForm: FC<FacilityFormProps> = ({
  formTemplateVersioningGroupId,
  clinicId,
  facilityId,
  officeHourId,
  formObjectKey,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const [createForm, { loading: createFormLoading }] = useCreateForm(
    { facilityId, officeHourId },
    router.pathname,
  );

  return (
    <Card style={{ backgroundColor: '#fdf5e3' }}>
      <Title>
        <div className={styles.questionIcon}>
          <QuestionOutlined />
        </div>
        {formatMessage({ id: 'survey' })}
      </Title>
      <p style={{ marginTop: 22 }}>{formatMessage({ id: 'survey.facility-requested-survey' })}</p>
      <AveliosButton
        loading={createFormLoading}
        type={'primary'}
        onClick={() =>
          createForm(clinicId, formTemplateVersioningGroupId, (formRevisionGroupId) =>
            buildFormForwardUrl(
              facilityId,
              clinicId,
              officeHourId,
              formObjectKey,
              formRevisionGroupId,
            ),
          )
        }
        block
        size={'large'}
      >
        {formatMessage({ id: 'survey.start' })}
      </AveliosButton>
    </Card>
  );
};
